(() => {
  const choicesFor = (variants, ties, needed) => {
    if (!Number.isInteger(needed) || needed < 1 || needed > 10000) return [];
    return variants.filter(v => v.available && v.ties === ties && v.bags > 0).map(v => {
      const min = Math.max(1, v.min), step = Math.max(1, v.step);
      const raw = Math.max(min, Math.ceil(needed / v.bags));
      const quantity = min + Math.ceil((raw - min) / step) * step;
      return {...v, quantity, totalBags:quantity * v.bags, spare:quantity * v.bags - needed, total:quantity * v.price};
    }).filter(v => v.max === null || v.quantity <= v.max).sort((a,b) => a.total - b.total || a.spare - b.spare || a.quantity - b.quantity);
  };
  class StoragePlanner454 extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (!this.querySelector('[data-sb-copy]')) {
        document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), {once:true});
        return;
      }
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.host = this.closest('product-454');
      this.dialog = this.querySelector('dialog');
      this.copy = JSON.parse(this.querySelector('[data-sb-copy]').textContent);
      this.variants = [...this.querySelectorAll('[data-sb-variant]')].map(el => {
        const d = el.dataset;
        return {id:d.id,ties:d.ties,bags:Number(d.bags),price:Number(d.price),available:d.available === 'true',min:Number(d.min),step:Number(d.step),max:d.max === '' ? null : Number(d.max)};
      });
      this.selected = this.variants.find(v => v.id === this.dataset.variant);
      if (!this.selected) return;
      this.state = {needed:100, ...this.host?.storagePlannerState, ties:this.selected.ties};
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.querySelector('[data-sb-needed]').value = this.state.needed;
      this.querySelector('[data-sb-ties]').value = this.state.ties;
      this.addEventListener('click', event => this.click(event), {signal});
      this.addEventListener('input', event => {
        if (event.target.matches('[data-sb-needed]')) {
          this.state.needed = event.target.value === '' ? '' : Number(event.target.value);
          this.remember(); this.render();
        }
      }, {signal});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-sb-ties]')) {
          this.state.ties = event.target.value; this.remember(); this.render();
        }
        if (event.target.matches('[data-sb-needed],[data-sb-ties]')) this.emit('plan_changed');
      }, {signal});
      this.host.addEventListener('change', event => {if (event.target.name === 'quantity') this.orderSummary();}, {signal});
      this.dialog.addEventListener('close', () => this.unlock(), {signal});
      this.querySelector('[data-sb-open]').hidden = false;
      this.render();
      queueMicrotask(() => this.orderSummary());
    }
    disconnectedCallback() {this.controller?.abort();clearTimeout(this.announceTimer);this.unlock();}
    remember() {if (this.host) this.host.storagePlannerState = {...this.state};}
    unlock() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow; this.previousOverflow = undefined;
      }
    }
    format(key, values = {}) {return Object.entries(values).reduce((s,[k,v]) => s.replaceAll(`__${k}__`, String(v)), this.copy[key] || '');}
    emit(action, detail = {}) {
      const data = {feature:'storage_run_planner',action,product_id:this.dataset.product,...detail};
      this.dispatchEvent(new CustomEvent('454:storage-planner',{bubbles:true,detail:data}));
      try {if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) Promise.resolve(window.Shopify?.analytics?.publish?.('454_storage_planner',data)).catch(() => {});} catch (_) {}
    }
    orderSummary() {
      const q = Number(this.host.querySelector('.f454-form [name="quantity"]')?.value);
      const output = this.host.querySelector('[data-sb-order-summary]');
      if (output) output.textContent = Number.isInteger(q) && q > 0 ? this.format('order',{quantity:q,bags:this.selected.bags,total:q*this.selected.bags}) : '';
    }
    click(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.matches('[data-sb-open]')) {
        this.dialog.showModal();this.previousOverflow = document.body.style.overflow;document.body.style.overflow = 'hidden';this.emit('opened');
      } else if (button.matches('[data-sb-close]')) this.dialog.close();
      else if (button.dataset.sbApply) this.apply(button);
    }
    render() {
      const valid = Number.isInteger(this.state.needed) && this.state.needed >= 1 && this.state.needed <= 10000;
      this.querySelector('[data-sb-needed]').setAttribute('aria-invalid',String(!valid));
      this.choices = choicesFor(this.variants,this.state.ties,this.state.needed);
      const results = this.querySelector('[data-sb-results]'); results.replaceChildren();
      const message = this.querySelector('[data-sb-message]');
      message.textContent = !valid ? this.copy.invalid : !this.choices.length ? this.copy.none : '';
      message.hidden = !message.textContent;
      this.choices.slice(0,3).forEach((choice,index) => {
        const card = document.createElement('article');card.className = 'sb454-result';
        if (index === 0) {const best = document.createElement('small');best.className = 'sb454-best';best.textContent = this.copy.lowest;card.append(best);}
        const top = document.createElement('div');top.className = 'sb454-result-top';
        const name = document.createElement('strong');name.textContent = this.format('packs',{quantity:choice.quantity,bags:choice.bags});
        const price = document.createElement('strong');price.textContent = this.money.format(choice.total/100);top.append(name,price);
        const coverage = document.createElement('p');coverage.textContent = this.format('coverage',{total:choice.totalBags,spare:choice.spare});
        const bottom = document.createElement('div');bottom.className = 'sb454-result-bottom';
        const unit = document.createElement('span');unit.textContent = this.format('perBag',{price:this.money.format(choice.price/choice.bags/100)});
        const use = document.createElement('button');use.type = 'button';use.dataset.sbApply = choice.id;use.textContent = this.copy.use;use.setAttribute('aria-label',this.format('useLabel',{quantity:choice.quantity,bags:choice.bags}));
        bottom.append(unit,use);card.append(top,coverage,bottom);results.append(card);
      });
      const best = this.choices[0];
      this.querySelector('[data-sb-coverage]').textContent = best ? this.format('packs',{quantity:best.quantity,bags:best.bags}) : '—';
      this.querySelector('[data-sb-spare]').textContent = best ? this.format('spare',{needed:this.state.needed,spare:best.spare}) : '';
      this.querySelector('[data-sb-fill]').style.width = best ? `${this.state.needed/best.totalBags*100}%` : '0%';
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {this.querySelector('[data-sb-status]').textContent = message.textContent || this.format('results',{count:Math.min(this.choices.length,3)});},300);
    }
    async apply(button) {
      const choice = this.choices.find(v => v.id === button.dataset.sbApply);
      if (!choice || !this.host?.updateProduct) return;
      this.querySelectorAll('[data-sb-apply]').forEach(b => b.disabled = true);
      this.remember();
      const host = this.host;
      const url = new URL(host.dataset.productUrl,location.origin);
      const current = new URL(location.href);
      ['preview_theme_id','_fd','pb','journeys_test'].forEach(k => {if (current.searchParams.has(k)) url.searchParams.set(k,current.searchParams.get(k));});
      url.searchParams.set('variant',choice.id);
      this.dialog.close();
      await host.updateProduct(url,null,true);
      const form = host.querySelector('.f454-form');
      if (!form || form.querySelector('[name="id"]')?.value !== choice.id) {
        const status = host.querySelector('[data-form-status]');if (status) status.textContent = this.copy.error;
        host.querySelectorAll('[data-sb-apply]').forEach(b => b.disabled = false);
        return;
      }
      const input = form.querySelector('[name="quantity"]');input.value = choice.quantity;
      if (!input.checkValidity()) {input.reportValidity();input.focus();return;}
      input.dispatchEvent(new Event('change',{bubbles:true}));
      const plan = form.querySelector('[name="selling_plan"]');
      if (plan && [...plan.options].some(o => o.value === '')) {plan.value = '';plan.dispatchEvent(new Event('change',{bubbles:true}));}
      const status = form.querySelector('[data-form-status]');
      if (status) status.textContent = this.format('applied',{quantity:choice.quantity,bags:choice.totalBags});
      this.emit('pack_selected',{variant_id:choice.id,quantity:choice.quantity,total_bags:choice.totalBags,value:choice.total/100,currency:this.dataset.currency});
      form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      form.querySelector('[type="submit"]')?.focus({preventScroll:true});
    }
  }
  if (!customElements.get('storage-planner-454')) customElements.define('storage-planner-454',StoragePlanner454);
})();
